import type { RenewalDurationKeys } from "~/tools/subscriptionUtils/contract";

const componentName = "prime.renewalDuration";

export const RENEWAL_DURATION_KEYS: RenewalDurationKeys = {
  singular: {
    month: `${componentName}.month`,
    quarter: `${componentName}.quarter`,
    year: `${componentName}.year`,
  },
  plural: {
    days: `${componentName}.days`,
    months: `${componentName}.months`,
    years: `${componentName}.years`,
  },
  adjective: {
    month: `${componentName}.monthly`,
    quarter: `${componentName}.quarterly`,
    year: `${componentName}.yearly`,
  },
};
